import styled from 'styled-components';
import Grid from 'styled-components-grid';
import {
  px, pt, pb, mb, mt, mx, mr, pl, pr
} from 'styled-components-spacing';

import { sectionSpacing } from '@components/Wrappers/styles';
import { styledButton } from '@styles/buttons';
import breakpoint from 'styled-components-breakpoint';
import theme from '@theme';
import Checkbox from '@components/Checkbox';
import ProgressBar from '@ramonak/react-progress-bar';

const { colors } = theme;
export const Styledform = styled.div`
  padding: 16px;
  ${breakpoint('mobile', 'desktop')`
    display: none;
  `}
`;


export const StyledMiniFlowWrapper = styled.div`
  ${mt(0)}
 border-radius: 10px;
  .styles__StyledCoverMaxWidth-sc-5r7r1a-0 {
    margin-bottom: 0px;
  }

  ${px(0.5)}
  display: block;
  ${sectionSpacing}
  .carousel {
    .control-dots {
      display: none;
      top: 0;
      pointer-events: none;
      .dot {
        background: ${colors.white};
      }
    }
    .slide {
      transition: none;
      height: 0;
      background: none;
      text-align: left;
    }
    .slide.selected {
      display: flex;
      height: auto;
    }
  }
  background-clip: content-box, padding-box;
  background-image:${props => (props.domain
    ? `linear-gradient(
    118.6deg,
    #5BA0A0 2%,
    #448989 30%,
    #276363 66%,
    #144D4D 100%
  )` : ` linear-gradient(
    118.6deg,
    #63aecf 0%,
    #629ece 30.63%,
    #458fd3 63.31%,
    #3a78b1 98.02%
  )`)};

  ${breakpoint('mobile')`
    ${pt(0)}
    scroll-margin-top:58px;
  `}

  ${breakpoint('desktop')`
    scroll-margin-top:81px;
    margin-bottom: 0px;
    .slider-wrapper {
      width: 100%;
    }
    .carousel {
      .control-dots {
        width: 100%;
        margin-left: 1rem;
      }
    }
    ${px(0)}
    ${pb(0)}
  `}
  margin-bottom: 0px;
`;


export const StyledName = styled.div`
display: flex;
justify-content: space-between;
padding:2% 5%;
`;


export const StyledPhone = styled.div`
  padding:2% 5%;
`;
export const StyledPhoneUnit = styled.div`
  padding: 2% 5%;
`;

export const StyledFirstName = styled.div`
  padding-right: 10px;
`;

export const StyledLastName = styled.div`
  padding-left: 10px;
`;
export const StyledCustomUnit = styled(Grid.Unit).attrs({
  size: { mobile: 6 / 12, desktop: 6 / 12 }
})`
  ${pb(3)}

  ${breakpoint('mobile', 'desktop')`
    input{
      border-radius: 10px;
    }
    

    &:nth-child(odd) {
      ${props => (props.treatmentFormName ? pl(2) : pr(2))}
    }

    &:nth-child(even) {
      ${props => (props.treatmentFormName ? pr(2) : pl(2))}
    }
  `}

  ${breakpoint('desktop')`
    &:nth-child(odd) {
      ${props => (props.treatmentFormName ? pl(2) : pr(4))}
    }

    &:nth-child(even) {
      ${props => (props.treatmentFormName ? pr(2) : pl(4))}
    }

    ${props =>
    props.treatmentFormName
      && `
    input{
      border-radius: 10px;
    }
    `}
  
  `}
`;
export const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: flex-start;
  color: ${theme.colors.white};
  padding-top: 0.5rem;
  padding-bottom: 0%.5rem;
  background-image: linear-gradient(
    118.6deg,
    #63aecf 0%,
    #629ece 30.63%,
    #458fd3 63.31%,
    #3a78b1 98.02%
  );
  font-size: 1rem;
  line-height: 1.5rem;
  text-align: center;
  font-weight: 500;

  ${breakpoint('desktop')`
    font-size: 1.5rem;
    line-height: 2.5rem;
  `}
`;

export const StyledItem = styled(Grid.Unit)`
  padding: 2% 5%;
  display: flex;
  text-align: start;
  font-size: 24px;
`;

export const StyledItemSpacing = styled(StyledItem)`
  display: flex;
  flex-direction: column;
  color: ${colors.white};
  font-size: 18px;
  line-height: 1.5;
  @media (min-width:500px)  and (max-width:738px){
    font-size: 20px;
  }
  color: ${colors.white};
`;

export const StyledFormHeading = styled.div`
 ${pb(0)};
  font-weight: 800;
  margin-top: 0px;
  color:${colors.white};
  padding: 1rem;
  text-align: start;
  font-size:28px;
  text-align: center;
  ${breakpoint('mobile', 'tablet')`
    padding: 0.5rem 1.5rem;
    font-size:20px;
  `}
  @media (min-width:500px) and (max-width:738px){
    font-size:28px;
  }
`;

export const StyledFormHeadline = styled(StyledItemSpacing)`
  font-weight: 500;
  margin-top: 0px;
  color:${colors.white};
  ${breakpoint('desktop')`
    text-align: start;
    font-size:28px;
    line-height: 1.57;
  `}
`;
export const StylePhone = styled.div`
  width: 92% !important;
`;
export const NameFlowWrapper = styled.div`
  padding:2% 0%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-content: space-around;
  align-items: center;
  width: 100% !important;
  margin:0.5rem 0rem;

  .MuiFormControl-root {
    width: 45%;
  }
`;

export const StyledHeadWrapper = styled.div`
`;

export const StyledNameWrapper = styled.div`
  display:flex;
`;

export const StyledHeadTitle = styled.span`
  width: 100%;
  padding: 2% 5%;
  color: ${colors.white};
  font-size: 18px;
  line-height: 1.4rem;
  @media (min-width:500px)  and (max-width:738px){
    font-size: 20px;
  }
  ${breakpoint('desktop')`
    font-size: 22px;
  `}
`;

export const StyledContentTop = styled.div`
  color: ${colors.darkBlue};
  width: 100%;
  padding:0.5rem;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  & > div {
    flex: 1;
  }

  ${breakpoint('mobile', 'tablet')`
    width: 100%;
  `}
`;

export const StyledPhoneFormUnit = styled(Grid.Unit)`
${pb(3)}

.flag-dropdown{
      border: none !important;
      background-color: unset !important;
    }

    ${props =>
    (props.treatmentFormName
      ? `
      .react-tel-input{
      input{
        border: none !important;
      }
    }
    `
      : `
    .react-tel-input{
      input{
        border: 1px solid ${colors.translucentDarkBlue} !important;
      }
    }
    `)}

${breakpoint('mobile', 'desktop')`
    input{
      border-radius: 10px;
    }

    
    .react-tel-input{
      input{
        border-radius: 10px !important;
      }
    }
`}
${breakpoint('desktop')`
  &:nth-child(odd) {
      pl(2)
    }

    &:nth-child(even) {
      pr(2)
    }

    ${props =>
    props.treatmentFormName
      && `
    input{
      border-radius: 10px;
    }

    .form-control{
      border-radius: 10px !important;
      
    }

    `}
`}
 .flag-dropdown{
      border: none;
    }

    ${props =>
    (props.treatmentFormName
      ? `
      .react-tel-input{
      input{
        border: none !important;
      }
    }
    `
      : `
    .react-tel-input{
      input{
        border: 1px solid ${colors.translucentDarkBlue};
      }
    }
    `)}
    `;
export const StyledInterviewWrapper = styled(Grid.Unit)`
  ${px(2)}
  ${pb(2)}
  form {
    width: 100% !important;
  }

  flex: 1;

  ${breakpoint('mobile', 'tablet')`
    width: 100%;
  `}

  ${breakpoint('desktop')`
    ${px(0)}
    ${pb(0)}

    display: flex;

    align-items: center;
    justify-content: center;
  `}
`;

export const StyledFormGrid = styled(Grid)`
  background-color:'unset';
  padding:1% 4%;
  position: relative;
  input {
    background-color: ${colors.white};
  }
  input[type='tel'] {
    background-color: ${colors.white} !important;
    box-sizing: border-box !important;
    border: 1px solid ${colors.translucentDarkBlue};
    outline: none;
  }
  ${({ flowForm }) => (flowForm ? mx(2) : '')}
  ${breakpoint('mobile', 'desktop')`
    px(0)
    py(0)
    mb(0)
    mt(0)
    border-radius: 8px;
  `};
`;

export const StyledProgressBar = styled(ProgressBar)`
  > div {
    background-color: ${colors.lightGray} !important;
    > div {
      background: none !important;
      height: 100% !important;
      background-color: ${colors.newThemeDarkBlue} !important;
    }
  }

  ${props => (props.formName ? mb(0) : mb(4))}
`;

export const StyledRadioGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 30%;
  font-weight: 600;
  line-height: 1.57;
  color: ${colors.white};
  .styles__StyledDotOuter-sc-5wnwlz-3.hwEvAB {
    background-color:${colors.white};
    border: 1px solid ${colors.translucentDarkBlue};
    box-sizing: content-box !important;
  }
  .styles__StyledDotInner-sc-5wnwlz-4.jntRSA {
    background-color:${props => (props.domain ? 'rgb(0, 81, 78)' : '#075175')};
    width: 100% !important;
    height: 100% !important;
    top: 1px !important;
    left: 1px !important;
    align-self: center !important;
  }
`;


export const StyledFormUnit = styled(Grid.Unit)`
  ${pb(3)}

  ${breakpoint('mobile', 'desktop')`
    input{
      border-radius: 10px;
    }
    
  `}
`;


export const StyledCheckbox = styled(Checkbox)`
  ${mr(4)}
  padding: 2px;
  background-color: ${colors.lightGray};
  box-sizing: content-box !important;
  margin-top: 6px;
  height: 40px;
  width: 40px;
  color: #0FA958;
  border: 1px solid ${colors.translucentDarkBlue};
  div {
    background-color: ${colors.lightGray};
    height: 40px;
    width: 40px;
  }
  svg {
    background-color: ${colors.lightGray};
    color: #0FA958;
  }
`;

export const TermsAndConditionsWrapper = styled.label`
  display: flex;
  align-items: center;
  color: ${colors.darkBlue};
  line-height: 1.57;
  font-size: 14px;
  ${mt(1)}
  ${mb(2)}
`;
export const StyledLabelTextWrapper = styled.div`
  ${breakpoint('desktop')`
    color: ${colors.white};
    width: '100%';
  `}
  ${breakpoint('mobile', 'desktop')`
  color: ${colors.white};
  `}
`;

export const StyledButtonSubmit = styled.button`
  ${styledButton}
  font-weight: bold;
  border-radius: 10px;
  width: 130px;
  align-self: center;
  background-color: ${colors.white};
  color: ${props => (props.domain ? 'rgb(0, 81, 78)' : colors.newThemeDarkBlue)};
  border: none;
  outline: none;
  padding: 10px;
  margin-bottom: 10px;
`;

export const StyledValidationMessage = styled.div`
  ${({ ValidationMessage }) => ValidationMessage
  && `
    padding-top:5px;
    font-size: 13px;
    color: #ffaebe;
    text-align: center;

  `}
  ${({ ValidationMessage }) => !ValidationMessage
  && `
    display:none;
  `}
`;
